export class HeroView {
  make(selector, biases) {
    this.deck = undefined;
    this.animationInterval = 500;
    this.detailedView = false;
    this.biases = biases;
    this.selector = selector;
    this.carouselContainer = document.querySelector(this.selector);

    biases.forEach((bias) => {
      let child = document.createElement('div');
      child.innerHTML = `<div class="square-button"></div>`;
      child.classList.add('animation', bias.slug);
      document.querySelector(`${this.selector} .biases .${(this.biases.indexOf(bias) >= biases.count() / 2 ? 'biases-right' : 'biases-left')}`).appendChild(child);
      bias.loadAnimation(document.querySelector(`.${bias.slug} .square-button`));
    });

    return this;
  }

  bindEvents(carousel) {
    carousel.elements.next.addEventListener('click', () => carousel.go('next'));
    carousel.elements.prev.addEventListener('click', () => carousel.go('prev'));

    [...carousel.elements.buttons].forEach((button) => {
      let index = [...carousel.elements.buttons].indexOf(button);
      button.addEventListener('mouseenter', () => {
        carousel.jumpToIndex(index);
        carousel.stop();
      });
      button.addEventListener('mouseleave', () => carousel.start());
      button.addEventListener('click', () => carousel.navigateToIndex(index));
    })
  }

  load(bias, advanced) {
    if (advanced) {
      this.showDetailedView();

      if (window.ga) {
        ga('send', 'pageview', this.path);
      }
    }

    [this.animatingStart].forEach((timeout) => {
      if (timeout) {
        clearTimeout(timeout)
      }
    });

    this.onAnimationBegin(bias);
    this.carouselContainer.classList.remove('animating', 'in', 'out');
    this.carouselContainer.classList.add('animating', 'in');
    this.animatingStart = setTimeout(() => {
      this.onAnimationStart(bias);
      this.carouselContainer.classList.remove('in');
      this.carouselContainer.classList.add('out');

      this.animatingEnd = setTimeout(() => {
        this.carouselContainer.classList.remove('animating', 'out');
        this.onAnimationEnd(bias)
      }, this.animationInterval)
    }, this.animationInterval);
  }

  onAnimationBegin(bias) {
    [...document.querySelectorAll('.biases .animation')].forEach((selector) => selector.classList.remove('left', 'right', 'center'));
    document.querySelector(`${this.selector} .biases .${this.biases.prev(bias).slug}`).classList.add('left');
    document.querySelector(`${this.selector} .biases .${this.biases.next(bias).slug}`).classList.add('right');
    document.querySelector(`${this.selector} .biases .${bias.slug}`).classList.add('center');

    // Debounce animation
    if (bias !== this.deck && ! bias.isAnimating) {
      bias.play();
    }

    this.deck = bias;
  }

  onAnimationStart(bias) {
    document.querySelector(this.selector + ' h1').innerText = bias.title;
    document.querySelector(this.selector + ' h3').innerText = bias.first;

    if (this.detailedView) {
      document.querySelector(this.selector + ' p.description').innerText = bias.description;
      document.querySelector(this.selector + ' p.example').innerText = bias.example;
      document.querySelector(this.selector + ' p.further-reading').innerHTML = bias.furtherReading;
      document.querySelector(this.selector + ' div.social').innerHTML = `<span class="fb-like" data-href="${window.location.protocol}//${window.location.hostname}/${bias.slug}" data-layout="button_count" data-action="like" data-show-faces="true" data-share="true"></span>`;

      window.document.title = bias.meta.seo.title ? bias.meta.seo.title : bias.pageTitle;
      $('meta[name="description"]').attr('content', bias.meta.seo.description);
      $.each(bias.meta.og, function(key, val) {
        $('meta[property="'+key+'"]').attr('content', val);
      });
      $('meta[property="og:url"]').attr('content', window.location.href);
      try {
        FB.XFBML.parse();
      } catch(ex) { }
    }
  }

  onAnimationEnd(bias) {
  }

  showDetailedView() {
    [...document.querySelectorAll(this.selector + ' .show-on-detailed-view')].forEach((element) => element.classList.add('visible'));
    [...document.querySelectorAll(this.selector + ' .hide-on-detailed-view')].forEach((element) => element.classList.add('hidden'));
    this.detailedView = true;
  }

  navigate(bias) {
    if (window.innerWidth > 991) {
      this.animate(bias);

      setTimeout(() => {
        window.location.href = bias.href;
      }, this.animationInterval);
    }
  }

  animate(bias) {
    [...document.querySelectorAll('.biases .animation')].forEach((selector) => selector.classList.remove('left', 'right', 'center'));
    this.carouselContainer.classList.add('navigating');
    let selected = document.querySelector(`${this.selector} .biases .${bias.slug}`);
    selected.classList.add('navigating');

    // Legacy Animation
    let clicked = $(selected);
    let animated = clicked.clone();
    clicked.css('visibility', 'hidden');

    let container = $(this.carouselContainer);
    container.css('height', container.height());

    let article = $(/<!--detailed-template-->([\s\S]+)<!--detailed-template-->/.exec(document.body.innerHTML).pop());
    article.prependTo(container);
    article.find('.square-button').html(clicked.html());

    let enlarged = article.find('.square-button');
    let destination = enlarged.offset();
    destination['font-size'] = '2em';

    article.hide();
    enlarged.css('visibility', 'hidden');

    container.velocity({opacity: 0}, this.animationInterval);

    //animate clicked picture to the center
    animated.appendTo('body')
      .addClass('bias-animated')
      .css('position', 'absolute')
      .offset(clicked.offset())
      .velocity(destination, {duration: this.animationInterval*2, easing: [250,0]});

    setTimeout(() => {
      //cleanup old content. the first child is our new content (article)
      container.children().not(":first-child").remove();
      container.velocity({opacity: 1}, this.animationInterval);
    }, this.animationInterval);

    setTimeout(() => {
      enlarged.css('visibility', 'visible');
    }, this.animationInterval*2);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/carousel/HeroView.js